import { ConvertBardToUnlayer } from './BardJsonToUnlayerJson.js';
export function convertHtmlStringToJson(htmlString) {
  return {
    version: '1.6.0',
    'content-width': 900,
    globals: {
      'font-imports': ['//fonts.googleapis.com/css?family=Merriweather:400,400italic,700italic,700|Open+Sans:400,400italic,700,700italic|Lato:400,400italic,700,700italic'],
      alignment: 'left',
      'background-color': '#ffffff',
      text: {
        h1: {
          color: '#383838',
          'font-family': 'Helvetica, Arial, sans-serif',
          'font-size': '22px',
          padding: '0',
          margin: '16px 0',
          'line-height': '1.6'
        },
        h2: {
          color: '#000000',
          'font-family': 'Helvetica, Arial, sans-serif',
          'font-size': '18px',
          padding: '0',
          margin: '15px 0',
          'line-height': '1.6'
        },
        p: {
          color: '#000000',
          'font-family': 'Helvetica, Arial, sans-serif',
          'font-size': '16px',
          padding: '0',
          margin: '13px 0',
          'line-height': '1.6'
        },
        b: {
          padding: '0',
          'line-height': '1.6'
        },
        i: {
          padding: '0',
          'line-height': '1.6'
        },
        ul: {
          padding: '0 0 0 40px',
          margin: '16px 0',
          'line-height': '1.6',
          'font-family': 'Helvetica, Arial, sans-serif',
          'font-size': '16px',
          color: '#000000'
        },
        ol: {
          padding: '0 0 0 40px',
          margin: '16px 0',
          'line-height': '1.6',
          'font-family': 'Helvetica, Arial, sans-serif',
          'font-size': '16px',
          color: '#000000'
        },
        li: {
          padding: '0',
          margin: '0',
          'line-height': '1.6'
        },
        a: {
          color: '#2BAADF',
          padding: '0',
          'line-height': '1.6'
        }
      }
    },
    rows: [{
      blocks: [{
        'block-type': 'html',
        html: {
          html: htmlString
        }
      }]
    }, {
      blocks: [{
        'block-type': 'email-footer',
        'email-footer': {
          address: '~Company.CanSpamAddressBlock~',
          alignment: 'center',
          'block-padding': 15,
          'unsubscribe-link': '~OptOut_BARD~',
          'unsubscribe-link-text': 'Unsubscribe'
        }
      }]
    }]
  };
}

/**
 * Creates Unlayer html block from Bard html
 * @param {String} html - Bard html content
 * @returns {Unlayer.HTMLContent} - Unlayer html block's content
 */
export function ConvertBardHtmlToUnlayerJson(html) {
  const bardJson = convertHtmlStringToJson(new DOMParser().parseFromString(html, 'text/html').body.innerHTML);
  return ConvertBardToUnlayer(bardJson, {
    applyStylesToHtml: false
  });
}